var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.5,
    y1: 12.5,
    x2: 13.94,
    y2: 12.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.5,
    y1: 21,
    x2: 21.5,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.5,
    y1: 4,
    x2: 21.5,
    y2: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu01);
export default __webpack_public_path__ + "static/media/Menu_01.864170ad18551f20c5044e3c8331f355.svg";
export { ForwardRef as ReactComponent };